interface FetchParams {
  method: 'GET' | 'POST' | 'DELETE';
  body?: object;
}

class FetchError extends Error {
  info: { [key: string]: unknown };

  status: number;

  constructor(
    message: string,
    info: { [key: string]: unknown },
    status: number
  ) {
    super(message);
    this.info = info;
    this.status = status;
  }
}

/**
 *
 * @param url : The route to be called. Also don't pass /notification, simply pass the route path
 * @param data : The data to be sent to the fetch
 * @param token : Session token for the user
 * @returns The response from the fetch
 */
const fetcher = async (url: string, data: FetchParams, token: string) => {
  const baseUrl = 'https://commenda-blog-1437f0014e61.herokuapp.com/api';

  const request = {
    method: data.method,
    body: JSON.stringify(data.body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await fetch(`${baseUrl}/${url}`, request);

  return response;
};

export const StrapiCMSFetcher = (data: FetchParams, token: string) => {
  return async (url: string) => {
    const res = await fetcher(url, data, token);

    const data2 = await res.json();

    if (!res.ok) {
      throw new FetchError(
        'An error occurred while fetching the data.',
        await res.json(),
        res.status
      );
    }

    return data2;
  };
};
